import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementPlus from 'element-plus';
import 'element-ui/lib/theme-chalk/index.css';
// import rulesConst from '@/utils/constant'   // 全局常量

createApp(App).use(store).use(router).use(ElementPlus).mount('#app');
